import type { OrderDetails } from '@/entities/order/model'
import type { DisplayState } from '@/entities/state/model'
import { formatTime } from '@/shared/lib/dayjs'

interface GetRapidOrderStatusProps {
  order: OrderDetails
  displayState?: DisplayState
  withoutBackdrop?: boolean
}

interface GetRapidOrderStatusReturn {
  statusText: string
  statusDisplayState?: DisplayState
  orderedTime: string
  isRapidOrderContext: boolean
}

/**
 * Utility function to handle rapid order status formatting logic
 * Determines if order details modal is opened from rapid orders context
 * and formats status accordingly
 */
export function getRapidOrderStatus({
  order,
  displayState,
  withoutBackdrop,
}: GetRapidOrderStatusProps): GetRapidOrderStatusReturn {
  // Check if this is a rapid order context (opened from rapid orders with ReadyToPick status)
  const isRapidOrderContext = Boolean(withoutBackdrop && order.status === 'ReadyToPick')
  const orderedTime = order.orderActivationTime
    ? `Order at ${formatTime(order.orderActivationTime, 'h:mm A')}`
    : 'Order at unknown time'

  // Use the rapid order formatting for status display when in rapid order context
  const statusDisplayState = isRapidOrderContext && displayState
    ? { ...displayState, stateDisplayName: orderedTime }
    : displayState

  const statusText = isRapidOrderContext ? orderedTime : order.status

  return {
    statusText,
    statusDisplayState,
    orderedTime,
    isRapidOrderContext,
  }
}
